import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Col} from 'reactstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
moment.locale("en");

export default class Footer extends Component{
    render(){
        return(
            <div>
                <Col xs={12} md={12} className="section">
                    <p>Harap menyelesaikan pembayaran maksimal <strong>{moment(this.props.expire).format('dddd, LL HH:mm')}</strong>. Pesanan ini akan otomatis batal
                    jika kami tidak menerima pembayaran. Klik <Link to="/helps/payment" title="Panduan Pembayaran">disini</Link> untuk mengetahui panduan pembayaran.</p>
                    <p>
                        Anda dapat check kembali invoice yang sudah terkirim ke email Anda. <br/>
                        <small>*Syarat & ketentuan berlaku.</small>
                    </p>
                </Col>
            </div>
        )
    }
}
